import { h, Component, Fragment } from 'preact';
import mapService from './../services/map.service';
import analytics from './../utilities/analytics.util.js';

export default class SearchComponent extends Component {
    constructor() {
        super();
        this.state = {
            searchValue: ''
        };
    }

    onKeyDown(e) {
        if (e.keyCode === 13) { // The ENTER key
            this.submitSearch(e.target.value);
        }
    }

    onChange(e) {
        this.setState({searchValue: e.target.value});
    }

    submitSearch(searchStr) {
        if (searchStr) {
            mapService.searchLocation(searchStr);
        }
    }

    onPlaceChanged(place, status) {
        if (place) {
            if (place.geometry) {
                analytics('search', { formatted_address: place.formatted_address });
                this.searchElement.value = place.formatted_address;
                this.setState({ searchValue: place.formatted_address });
            }
        }
        else {
            if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                alert('No location found for search');
            }
            else {
                console.error(status);
                alert('Search failed unexpectedly');
            }
        }
    }

    componentDidMount() {
        mapService.initializeSearch(this.searchElement, (place, status) => this.onPlaceChanged(place, status));
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <form class="widget widget-search" role="search" onkeydown={e => e.keycode !== 13} onsubmit={(e) => e.preventDefault()}>

                    <label for="search" class="hidden">Search</label>

                    <input type="text" name="search" id="search" placeholde="Search for an Address" value={self.state.searchValue}
                        onchange={e => self.onChange(e)} onkeydown={e => self.onKeyDown(e)} data-ga="Search Input"
                        ref={s => {
                            self.searchElement = s;
                        }} />

                    <button type="button" onclick={e => self.submitSearch(self.state.searchValue)} data-ga="Search Button">
                        <span class="text-hidden">Submit</span>
                        <span class="no-search"></span>
                    </button>

                </form>
            </Fragment>
        );
    }
}
